import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Select,
  Table,
  Divider,
  message,
} from "antd";
import AddEquipmentModal from "../components/AddEquipment";
const BreadCrumbData = [
  { path: "/page/equipment/retailequipment", name: "设备" },
  { path: "/page/equipment/retailequipment", name: "体验设备" },
];
const { Option } = Select;
const { Column } = Table;
class RetailEquipment extends React.Component {
  state = {
    visible: false,
    list: [],
    total: 0,
    listQuery: {
      equipmentId: "",
      business: "",
      status: "",
      pageNum: 1,
      pageSize: 10,
    },
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(values);

        this.setState(
          {
            listQuery: { ...this.state.listQuery, ...values, pageNum: 1 },
          },
          () => {
            this.getEquipmentList();
            message.success("搜索成功");
          }
        );
      }
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };
  getEquipmentList = () => {
    console.log(1);
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { list, listQuery, total, visible } = this.state;
    return (
      <React.Fragment>
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle">
          <Row>
            <Col span={18}>
              <Form layout="inline" onSubmit={this.handleSubmit}>
                <Form.Item>
                  {getFieldDecorator(
                    "equipment",
                    {}
                  )(<Input style={{ width: 200 }} placeholder="设备编号" />)}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "business",
                    {}
                  )(<Input style={{ width: 200 }} placeholder="商户名称" />)}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "status",
                    {}
                  )(
                    <Select style={{ width: 180 }} placeholder="全部类型">
                      <Option value=""> 全部类型</Option>
                      <Option value="bind"> 已绑定</Option>
                      <Option value="unbind"> 未绑定</Option>
                    </Select>
                  )}
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    搜索
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col span={6} align="right">
              <Button
                type="primary"
                onClick={() => this.setState({ visible: true })}
              >
                新增设备
              </Button>
            </Col>
          </Row>
        </div>
        <div className="content">
          <Table
            dataSource={list}
            rowKey="equipmentId"
            pagination={{
              total: total,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              //   onChange: (page, pageSize) => {
              //     this.setState(
              //       {
              //         listQuery: { ...listQuery, pageNum: page }
              //       },
              //       () => this.getEmployeeList()
              //     );
              //   },
              //   onShowSizeChange: (current, pageSize) => {
              //     this.setState(
              //       {
              //         listQuery: { ...listQuery, pageSize }
              //       },
              //       () => this.getEmployeeList()
              //     );
              //   }
            }}
          >
            <Column
              title="设备编号"
              dataIndex="equipmentId"
              key="equipmentId"
            />
            <Column title="控制板编号" dataIndex="controlId" key="controlId" />
            <Column
              title="设备模板"
              dataIndex="equipmentTemplate"
              key="equipmentTemplate"
            />
            <Column
              title="绑定状态"
              dataIndex="bind"
              key="bind"
              render={(text) => (text ? "已绑定" : "未绑定")}
            />
            <Column title="使用商户" dataIndex="business" key="business" />
            <Column
              title="安装状态"
              dataIndex="isInstall"
              key="isInstall"
              render={(text) => (text ? "已安装" : "未安装")}
            />
            <Column title="安装版本" dataIndex="version" key="version" />
            )} />
          </Table>
        </div>
        <AddEquipmentModal
          visible={visible}
          handleCancel={this.handleCancel}
          getEquipmentList={this.getEquipmentList}
        ></AddEquipmentModal>
      </React.Fragment>
    );
  }
}
export default Form.create()(RetailEquipment);
